import type { GetVehicle } from '../helpers/vehicle.schema';

export const motSectionTransformer = (vehicle: GetVehicle) => ({
	advisories: vehicle.motData.advisories,
	advisoriesAvailable: !vehicle.motData.MOTAdvisoriesUnavailable,
	lastMotDate: vehicle.lastMOTDate,
	motStatus: vehicle.motData.status,
});
